import React from 'react'
import { useIntl } from 'react-intl'
import Caption from '../Typography/Caption'
import FormatCurrency from 'components/Common/FormatCurrency'

interface Props {
  value: number
  /**
   * @default roundedDollar
   */
  priceFormat?: React.ComponentProps<typeof FormatCurrency>['format']
  /**
   * @default neutral-two
   */
  colour?: 'neutral-two' | 'neutral-three'
}

function PriceRowSale(props: Props) {
  const { value, priceFormat = 'roundedDollar', colour = 'neutral-two' } = props
  const intl = useIntl()
  const wasPriceLabel = intl.formatMessage(
    {
      id: 'OZ5v0lT0dzaeP1rwP_pV',
      defaultMessage: 'Was {price}',
      description: 'Strikethrough sale label showing previous monetary price',
    },
    { price: <FormatCurrency value={value} format={priceFormat} /> },
  )

  return <Caption
    as="s"
    variant="medium"
    colour={colour}
  >
    {wasPriceLabel}
  </Caption>
}

export default PriceRowSale
